import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';
// disable the following line if you don't want to use google-libphonenumber
import * as libPhNo from 'google-libphonenumber';


@Component({
    selector: 'app-standard-phone-input',
    templateUrl: './standard-phone-input.component.html',
    styleUrls: ['./standard-phone-input.component.scss'],
    standalone: false
})
export class StandardPhoneInputComponent {
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  selectedCountryISO!: CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.Ireland,
    CountryISO.UnitedKingdom,
    CountryISO.Austria,
    CountryISO.Belgium,
    CountryISO.France,
    CountryISO.Germany,
    CountryISO.Netherlands,
    CountryISO.Poland,
  ];
  // @Input() formControl: FormControl;
  @Input() control!: FormControl;
  @Input() fieldId = 'phone';
  @Input() defaultCountry = CountryISO.Ireland;

  @Output() OnCountryChange: EventEmitter<any> = new EventEmitter<any>();
  phoneNo: any;
  constructor() { }

  ngOnInit(): void {
    // this.control.valueChanges.subscribe((val: any) => {
    //   if (val?.countryCode && val?.countryCode !== '') {
    //     this.selectedCountryISO = val.countryCode.toLowerCase();
    //   } else {
    //     this.selectedCountryISO = CountryISO.Ireland;
    //   }
    // })
  }

  onCountryChange_internal(event: any) {
    // console.log('onCountryChange', event);
    this.OnCountryChange.emit(event);

    let pnu = libPhNo.PhoneNumberUtil.getInstance();
    let pnt = libPhNo.PhoneNumberType;
    // let exampleNumb = pnu.getExampleNumberForType(event.iso2, pnt.FIXED_LINE_OR_MOBILE);
    let exampleNumb = pnu.getExampleNumberForType(event.iso2, pnt.FIXED_LINE_OR_MOBILE);
    let regCode = pnu.getRegionCodeForCountryCode(exampleNumb.getCountryCode() as number);
    // console.log('regCode', regCode);
    // console.log('exampleNumb', event.iso2, exampleNumb);
    let natNum = exampleNumb.getNationalNumber();
    // console.log('natNum', natNum);

  }
}
